import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';

const calendarStyles = {
  '& .react-datepicker': {
    fontFamily: mixins.fontFamilyPlusSans,
    border: '1px solid #E0E0E0',
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    padding: 8,
    background: 'white'
  },
  '& .react-datepicker__header': {
    backgroundColor: 'white',
    borderBottom: 'none',
    paddingTop: 0,
    paddingBottom: 8
  },
  '& .react-datepicker__day-names': {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 4
  },
  '& .react-datepicker__day-name': {
    color: '#666',
    fontSize: 14,
    fontWeight: 500,
    width: 36,
    lineHeight: '36px',
    margin: 2
  },
  '& .react-datepicker__month': {
    margin: 0
  },
  '& .react-datepicker__week': {
    display: 'flex',
    justifyContent: 'space-around'
  },
  '& .react-datepicker__day': {
    color: '#2E2E2E',
    fontSize: 14,
    width: 36,
    height: 36,
    lineHeight: '36px',
    margin: 2,
    borderRadius: 8,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      borderRadius: 8
    }
  },
  '& .react-datepicker__day--selected, & .react-datepicker__day--keyboard-selected': {
    backgroundColor: `${mixins.amethyst} !important`,
    color: 'white !important',
    fontWeight: 600,
    borderRadius: 8
  },
  '& .react-datepicker__day--today': {
    fontWeight: 600,
    color: mixins.amethyst,
    backgroundColor: 'transparent'
  },
  '& .react-datepicker__day--today.react-datepicker__day--selected': {
    backgroundColor: `${mixins.amethyst} !important`,
    color: 'white !important'
  },
  '& .react-datepicker__day--outside-month': {
    color: '#BDBDBD'
  },
  '& .react-datepicker__day--disabled': {
    color: '#E0E0E0',
    cursor: 'not-allowed',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  '& .react-datepicker__triangle': {
    display: 'none'
  }
};

const useDateStyles = makeStyles({
  '@global': {
    '#react-datepicker-portal': { zIndex: '9999 !important' }
  },
  datePickerPortalWrapper: calendarStyles,
  label: {
    fontWeight: mixins.fontWeight400,
    fontSize: 14,
    fontFamily: mixins.fontFamilyPlusSans,
    color: mixins.greyScaleColor,
    lineHeight: '22px'
  },
  dateWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& .react-datepicker-wrapper': {
      width: '100%',
      height: '100%'
    },
    '& .react-datepicker__input-container': {
      width: '100%',
      height: '100%'
    }
  },
  datePickerContainer: {
    position: 'relative',
    width: 144,
    height: 48
  },
  datePickerPopper: {
    zIndex: '9999 !important'
  },
  dateInput: {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    borderRadius: 4,
    padding: '12px 40px 12px 12px',
    backgroundColor: '#FFFFFF',
    border: `1px solid ${mixins.amethyst}`,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight400,
    fontFamily: mixins.fontFamilyPlusSans,
    color: '#2E2E2E',
    outline: 'none',
    cursor: 'pointer',
    '&::placeholder': {
      color: '#9CA3AF',
      opacity: 1
    },
    '&:focus': {
      borderColor: mixins.amethyst
    }
  },
  calendarIcon: {
    position: 'absolute',
    right: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none',
    zIndex: 1,
    '& svg': {
      fontSize: 18,
      color: '#2E2E2E'
    }
  },
  customHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 12px',
    marginBottom: 8
  },
  navButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 16,
    padding: '4px 8px',
    color: mixins.amethyst,
    minWidth: 32,
    transition: 'color 0.2s ease',
    '&:hover': {
      color: mixins.amethyst
    },
    '&:focus': {
      outline: 'none',
      color: mixins.amethyst
    },
    '&:disabled': {
      color: '#E0E0E0',
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    }
  },
  monthYearLabel: {
    fontSize: 16,
    fontWeight: 600,
    color: '#2E2E2E',
    fontFamily: mixins.fontFamilyPlusSans,
    flex: 1,
    textAlign: 'center'
  },
  dateInputError: {
    border: `2px solid ${mixins.accentRedDark} !important`,
    '&:focus': {
      borderColor: `${mixins.accentRedDark} !important`
    }
  }
});

export default useDateStyles;
